import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const CountryColumn = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { labelConfiguration, externalFulfillmentConfiguration } =
    useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) ?? {};

  const shipTo = labelConfiguration?.shipTo ?? externalFulfillmentConfiguration?.shipTo;

  const { countryCode } = shipTo ?? {};

  return countryCode ?? '';
};

CountryColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Country = {
  getMessageDescriptor: () => messages.country,
  id: 'country',

  render: (data) => {
    return <CountryColumn fulfillmentId={data.id} />;
  },
};
